<template>
  <div>
    <TheHeader />
    <section v-if="dadosAssociado.codsocio" id="relcontainer">
      <div class="container pb-5">
        <div class="row">
          <div class="col-12 py-4">
            <router-link
              class="btn-voltar d-print-none"
              :to="{ name: 'relatoriosaude' }"
            >
              <span class="material-icons">chevron_left</span> Relatórios Planos
            </router-link>
            <h1 class="title mt-4 text-uppercase">
              RELATÓRIO DE COPARTICIPAÇÃO
            </h1>
          </div>
        </div>

        <div class="row align-items-center mt-4">
          <div class="col-md-6">
            <div class="vidas-lista">
              <vue-select
                class="vue-select2"
                name="select2"
                :options="vidasLista"
                :searchable="true"
                placeholder="Selecione uma vida"
                language="pt"
                @input="buscarVida"
              >
                <span slot="no-options"> Nenhum resultado. </span>
              </vue-select>
            </div>
          </div>
          <div class="col-md-6 mt-3 mt-md-0 text-md-right d-print-none">
            <button
              type="button"
              class="btn btn-outline-danger mr-1 font-weight-bold"
              @click="generateReport"
            >
              BAIXAR PDF
              <IconPdf class="ml-2" width="15" heigth="15" />
            </button>
          </div>
        </div>

        <div v-if="vidas.length > 0">
          <div class="bg-white rounded p-4 mt-4 border border-light">
            <div class="row">
              <div class="col-12">
                <div class="rel-title">ORGANIZAÇÃO</div>
                <div class="rel-value-reg">{{ dadosAssociado.entidade }}</div>
              </div>
              <div class="col-md-4 mt-4">
                <div class="rel-title">ASSOCIADO</div>
                <div class="rel-value-reg">{{ dadosAssociado.codsocio }}</div>
              </div>
              <div class="col-md-2 mt-4">
                <div class="rel-title">DATA DA FILIAÇÃO</div>
                <div class="rel-value-reg">{{ dadosAssociado.dtfiliacao }}</div>
              </div>
              <div class="col-md-6 mt-4">
                <div class="rel-title">ENDEREÇO</div>
                <div class="rel-value-reg">{{ dadosAssociado.endereco }}</div>
              </div>
            </div>
          </div>

          <div class="row" v-if="vidas.length > 1">
            <div
              class="col-md-4 mt-4"
              v-for="(item, index) in itemsTop"
              :key="index"
            >
              <ItemCard
                ref="itemCard"
                :title="item.titulo"
                :value="String(item.valor)"
              />
            </div>
          </div>

          <div class="mt-5">
            <h3 class="subtitle">RELATÓRIO POR VIDAS</h3>
            <div v-for="(vida, i) in vidas" :key="i">
              <div class="bg-vida rounded p-4 mt-4 border border-light">
                <div class="row align-items-center">
                  <div class="col-md-5 rel-value d-flex align-items-center" style="margin-right: 50px">
                    {{ vida.nome }}
                    <span style="font-size: 12px; color: #fff; background-color: #05428e; padding: 4px 10px; border-radius: 12px; margin-left: 15px; letter-spacing: 1px;">
                      {{ vida.tipo }}
                    </span>
                  </div>
                  <div class="col text-right d-flex" style="margin-right: 120px">
                    <div class="field" style="padding-right: 10px">Carteira</div>
                    <div class="rel-value">{{ vida.carteira }}</div>
                  </div>
                  <div class="col text-right d-flex" style="padding-right: 5px">
                    <div class="field" style="padding-right: 10px">Total</div>
                    <div class="rel-value">
                      {{ totalVida(vida.codvida) | currency }}
                    </div>
                  </div>
                </div>
              </div>
              <Lista
                class="bg-white rounded pt-3 px-3 w-100"
                :items="filtrarVidas(vida.codvida)"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section v-else>
      <loading />
    </section>
    <vue-html2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="760"
      :filename="'extratoUtilizacaoUnimed' + urlParams.periodo"
      :pdf-quality="1"
      :manual-pagination="false"
      pdf-format="letter"
      pdf-orientation="landscape"
      pdf-content-width="1060px"
      ref="html2Pdf"
    >
      <section slot="pdf-content" class="pdf-content">
        <section class="pdf-item container pb-1">
          <div class="row">
            <div class="col-12 py-1 d-flex justify-content-between">
              <h1 class="title mt-4 text-uppercase">
                RELATÓRIO DE COPARTICIPAÇÃO
              </h1>
              <img
                src="@/assets/img/logo.png"
                class="img-fluid"
                width="160"
                alt="logo"
              />
            </div>
          </div>
          <div class="bg-white rounded p-1 mt-1 border border-light">
            <div class="row">
              <div class="col-12">
                <div class="rel-title">ORGANIZAÇÃO</div>
                <div class="rel-value-reg">{{ dadosAssociado.entidade }}</div>
              </div>
              <div class="col-md-4 mt-4">
                <div class="rel-title">ASSOCIADO</div>
                <div class="rel-value-reg">{{ dadosAssociado.codsocio }}</div>
              </div>
              <div class="col-md-2 mt-4">
                <div class="rel-title">DATA DA FILIAÇÃO</div>
                <div class="rel-value-reg">{{ dadosAssociado.dtfiliacao }}</div>
              </div>
              <div class="col-md-6 mt-4">
                <div class="rel-title">ENDEREÇO</div>
                <div class="rel-value-reg">{{ dadosAssociado.endereco }}</div>
              </div>
            </div>
          </div>
        </section>
        <section
          class="pdf-item container"
          v-if="vidas.length > 1"
        >
          <div class="row">
            <div
              class="col-md-4 mt-1"
              v-for="(item, index) in itemsTop"
              :key="index"
            >
              <ItemCard
                ref="itemCard"
                :title="item.titulo"
                :value="String(item.valor)"
              />
            </div>
          </div>
        </section>
        <section class="pdf-item mt-1 py-3 container">
          <h3 class="subtitle">RELATÓRIO POR VIDAS</h3>
        </section>
        <div v-for="(vida, i) in vidas" :key="i">
          <section class="pdf-item container">
            <div class="bg-vida rounded p-3 mt-1 border border-light">
              <div class="row align-items-center">
                <div class="col-md-5 rel-value d-flex align-items-center" style="margin-right: 50px">
                  {{ vida.nome }}
                  <span style="font-size: 10px; color: #fff; background-color: #6c757d; padding: 3px 8px; border-radius: 10px; margin-left: 10px;">
                    {{ vida.tipo }}
                  </span>
                </div>
                <div class="col text-right d-flex" style="margin-right: 120px">
                  <div class="field" style="padding-right: 10px">Carteira</div>
                  <div class="rel-value">{{ vida.carteira }}</div>
                </div>
                <div class="col text-right d-flex">
                  <div class="field" style="padding-right: 5px">Total</div>
                  <div class="rel-value">
                    {{ totalVida(vida.codvida) | currency }}
                  </div>
                </div>
              </div>
            </div>
            <Lista
              class="bg-white rounded pt-0 px-1 w-auto"
              :items="filtrarVidas(vida.codvida)"
            />
          </section>
        </div>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
import TheHeader from "@/components/TheHeader.vue";
import ItemCard from "@/components/relatorio/ItemCard";
import Lista from "@/components/relatorio/ListaUnimed";
import IconPdf from "@/components/icones/Pdf";
import VueHtml2pdf from "vue-html2pdf";
import VueSelect from "vue-select";

export default {
  name: "extrato-utilizacao-unimed",
  components: {
    VueSelect,
    TheHeader,
    ItemCard,
    Lista,
    IconPdf,
    VueHtml2pdf,
  },
  data() {
    return {
      total: 0,
      relData: [],
      vidas: [], // Agora é um Array
      dadosAssociado: {},
      agrupados: {},
      itemsTop: [],
      vidasLista: [],
      vidaSelecionada: "",
    };
  },
  filters: {
    filterData(val) {
      return val.replaceAll("/", "-");
    },
    currency(valor) {
      var formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
      return formatter.format(valor);
    },
  },
  props: {
    tipo: String,
    periodo: String,
  },
  computed: {
    urlParams() {
      return this.$route.params;
    },
  },
  methods: {
    getRelatorio() {
      this.$http
        .get(
          `/api/CdlBh/RelatorioExtratoUtilizacaoCoParUnimed?AnoMes=${this.urlParams.periodo}`
        )
        .then((response) => {
          this.relData = response.data.coparticipacao;
          this.dadosAssociado = response.data;

          this.relData.forEach((el) => {
            const temVida = this.vidasLista.filter(
              (vida) => vida.value == el.codvida
            );

            if (temVida.length === 0) {
              this.vidasLista.push({
                label: el.pf,
                value: el.codvida,
              });
            }
          });

          this.vidasLista.sort(function (x, y) {
            return x.label == y.label ? 0 : x.label > y.label ? 1 : -1;
          });

          this.vidasLista.unshift({
            label: "TODOS",
            value: 0,
          });
        })
        .then(() => {
          this.relData.forEach((el) => {
            this.total += el.vlrtotal;
          });
        })
        .then(() => {
          this.itemsTop = [
            {
              titulo: "Período",
              valor: this.formatDate(this.urlParams.periodo),
            },
            {
              titulo: "Total de Vidas",
              valor: this.vidasLista.length - 1, // Descontar o "TODOS"
            },
            {
              titulo: "Total",
              valor: this.$options.filters.currency(this.total),
            },
          ];
        })
        .catch((error) => {
          console.log(error);
        });
    },
    filtrarVidas(codvida) {
      return this.relData.filter((el) => el.codvida === codvida);
    },
    buscarVida(prop) {
      this.vidas = []; // Reinicia o array
      
      // FUNÇÃO INTELIGENTE: Busca 'TITULAR' em qualquer chave do JSON
      const identificarTipo = (el) => {
        for (const key in el) {
          if (el[key] === 'TITULAR') {
            return 'TITULAR';
          }
        }
        return 'DEPENDENTE';
      };

      if (prop.value == 0) {
        this.relData.forEach((el) => {
          const jaExiste = this.vidas.find(v => v.codvida === el.codvida);
          if (!jaExiste) {
            this.vidas.push({
              codvida: el.codvida,
              nome: el.pf,
              carteira: el.numcarteira,
              tipo: identificarTipo(el) // Aplica aqui
            });
          }
        });
      } else {
        const result = this.relData.filter((el) => el.codvida === prop.value);
        if (result.length > 0) {
          const el = result[0];
          this.vidas.push({
            codvida: el.codvida,
            nome: el.pf,
            carteira: el.numcarteira,
            tipo: identificarTipo(el) // Aplica aqui também
          });
        }
      }
    },
    totalVida(codvida) {
      var servicos = this.relData.filter((el) => el.codvida === codvida);
      var total = 0;
      servicos.forEach((el) => {
        total += el.vlrtotal;
      });

      return total;
    },
    formatDate(date) {
      const ano = date.substr(0, 4);
      const mes = this.getMes(date.substr(5, 2));
      return `${mes} / ${ano}`;
    },
    getMes(mes) {
      const m = parseInt(mes) - 1;
      return this.$store.state.calendarOpts.pt.monthNames[m];
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
  },
  created() {
    this.getRelatorio();
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/_vars.scss";

.vidas-lista /deep/ {
  .v-select {
    .vs__dropdown-toggle {
      border-radius: 6px;
      background: white;
      border-bottom: none !important;
      height: 45px;
      display: flex;
      align-items: center;
      position: relative;
      .vs__selected {
        position: absolute;
        left: 10px;
        top: 14px;
      }
      .vs__selected-options {
        width: calc(100% - 40px);
        input {
          width: 100%;
          border: none;
          height: 40px;
          padding: 5px 15px;
        }
      }
      .vs__actions {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
        cursor: pointer;
        .vs__clear {
          background: transparent;
          border: none;
          margin-left: -20px;
          margin-right: 10px;
        }
      }
    }
    .vs__dropdown-menu {
      background: white;
      border: none;
      padding: 10px;
      border-bottom-left-radius: 6px;
      border-bottom-right-radius: 6px;
      li {
        padding-top: 5px;
        padding-bottom: 5px;
        cursor: pointer;
        &:hover {
          color: black;
          font-weight: 700;
        }
      }
    }
    &.vs--open {
      .vs__dropdown-toggle {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
  }
}

.btn-voltar {
  color: $primary;
  font-weight: 700;
  font-size: 20px;
  display: inline-flex;
  align-items: center;
}
.bg-vida {
  background-color: #e3e6f0;
}
.title {
  color: $primary;
  font-weight: 700;
  font-size: 24px;
}
.flex-item {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  font-weight: 900;
  text-align: left;
}
h3.subtitle {
  font-size: 1.5rem;
  font-weight: 700;
  color: #05428e;
}
.rel-value {
  font-weight: bold;
  font-size: 20px;
  text-transform: uppercase;
  color: #000;
}
.rel-title {
  font-weight: 300;
  font-size: 14px;
  margin-bottom: 10px;
}
.rel-value-reg {
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
  color: #000;
  line-height: 1.4;
}
table {
  width: fit-content;
  margin-top: 20px;
}
td {
  font-size: 0.8rem;
}
.rel-block {
  width: 100%;
  border-radius: 5px 0;
  background: #fff;
  margin: 25px 15px 15px 15px;
}
.rel-data {
  justify-content: space-between;
  color: #6c757d;
  .titulo {
    font-weight: bold;
    font-size: 20px;
    color: #000;
    margin-bottom: 20px;
  }
  .item {
    border-top: 2px solid #6c757d;
    padding: 10px 0;
    margin: 0;
    .field {
      padding: 0px !important;
    }
    .value {
      text-align: right;
      padding: 0px !important;
    }
  }
}
.total {
  justify-content: space-between;
  color: #6c757d;
  .item {
    border-top: 2px solid #6c757d;
    padding-top: 30px;
    padding-right: 0px;
    margin: 0;
    .field {
      text-align: right;
    }
    .value {
      text-align: right;
      font-weight: bold;
      font-size: 20px;
      color: #000;
      padding: 0px !important;
    }
  }
}
.first {
  padding-right: 3px !important;
}
.last {
  padding-left: 3px !important;
}
.other {
  padding-right: 3px !important;
  padding-left: 3px !important;
}
.pdf-content {
  .title {
    font-size: 16px;
  }
  h3.subtitle {
    font-size: 1rem;
  }
  .rel-value {
    font-size: 15px;
    font-weight: 800;
  }
  .rel-title {
    font-size: 14px;
    font-weight: 800;
  }
  .rel-value-reg {
    font-size: 12px;
    font-weight: 600;
    color: #000;
  }
  .bg-vida {
    background-color: (RGB 240, 240, 240);
  }
  .item-card {
    color: black !important;
    font-weight: 700 !important;
  }
}
</style>